<template>
    <div>
        последовательность
    </div>
</template>

<script>
    export default {
        name: "ConstructorSequence"
    }
</script>

<style scoped>

</style>
